import React from 'react';

export const ForgePioGoogleDriveSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2230_19249)">
				<path
					d="M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z"
					fill="#0066DA"
				/>
				<path
					d="M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z"
					fill="#00AC47"
				/>
				<path
					d="M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z"
					fill="#EA4335"
				/>
				<path
					d="M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z"
					fill="#00832D"
				/>
				<path
					d="M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z"
					fill="#2684FC"
				/>
				<path
					d="M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z"
					fill="#FFBA00"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2230_19249">
					<rect width="16" height="14.6667" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
